import { useFilterCategory } from './useFilterCategory'
import { useFiltersToggle } from '../CollectionFilter/useFiltersToggle'

export function useFilterContext({
  metaFilters
}: {
  metaFilters?: {
    multi: boolean
    show: boolean
  }
}) {
  const { isFiltersOpen, closeFilters, openFilters } = useFiltersToggle()
  const [filterCategory, setFilterCategory] = useFilterCategory(
    metaFilters ? metaFilters.multi : false
  )

  return {
    filterCategory,
    setFilterCategory,
    isFiltersOpen,
    closeFilters,
    openFilters,
    showFilters: metaFilters?.show
  }
}
